import { AtlassianIcon } from '@atlaskit/logo/atlassian-icon';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { CustomerServiceManagementIcon } from '@atlaskit/logo/customer-service-management/icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { JiraServiceManagementIcon } from '@atlaskit/logo/jira-service-management-icon';

import { type RovoLogo, RovoLogoFromLogo } from './icons';
import { ProductCategoryKey } from './product-category-key';
import { type ProductKeys as AllProductKeys, ProductKeys } from './product-keys';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ProductCategoryKey } from './product-category-key';

export interface ProductCategoryConfig {
	productCategory: ProductCategoryKeys;
	displayName: React.ReactNode;
	Icon: RovoLogo;
	products: AllProductKeys[];
}

export type ProductCategoryKeys = (typeof ProductCategoryKey)[keyof typeof ProductCategoryKey];

export const productCategories: Record<ProductCategoryKeys, ProductCategoryConfig> = {
	[ProductCategoryKey.Confluence]: {
		productCategory: ProductCategoryKey.Confluence,
		displayName: 'Confluence',
		Icon: RovoLogoFromLogo(ConfluenceIcon, 'Confluence'),
		products: [ProductKeys.Confluence, ProductKeys.ConfluenceDC],
	},
	[ProductCategoryKey.Atlas]: {
		productCategory: ProductCategoryKey.Atlas,
		displayName: 'Atlas',
		Icon: RovoLogoFromLogo(AtlassianIcon, 'Atlas'),
		products: [ProductKeys.Atlas, ProductKeys.AtlassianWebCrawler],
	},
	[ProductCategoryKey.Jira]: {
		productCategory: ProductCategoryKey.Jira,
		displayName: 'Jira',
		Icon: RovoLogoFromLogo(JiraIcon, 'Jira'),
		products: [ProductKeys.Jira, ProductKeys.JiraDC],
	},
	[ProductCategoryKey.JiraServiceManagement]: {
		productCategory: ProductCategoryKey.JiraServiceManagement,
		displayName: 'Jira Service Management',
		Icon: RovoLogoFromLogo(JiraServiceManagementIcon, 'Jira Service Management'),
		products: [ProductKeys.JiraServiceManagement, ProductKeys.JsmDC],
	},
	[ProductCategoryKey.CustomerServiceManagement]: {
		productCategory: ProductCategoryKey.CustomerServiceManagement,
		displayName: 'Customer Service Management',
		Icon: RovoLogoFromLogo(CustomerServiceManagementIcon, 'Customer Service Management'),
		products: [ProductKeys.CustomerServiceManagement],
	},
};

export const getCategoryForProduct: (
	productKey: AllProductKeys,
) => ProductCategoryConfig | undefined = (productKey: AllProductKeys) => {
	return Object.values(productCategories).find(
		(categoryConfig) => categoryConfig.productCategory === productKey,
	);
};
